import { useState, useRef, useCallback } from "react";

export const useHoverDropdown = (duration = 300) => {
  const [isOpen, setIsOpen] = useState(false);
  const [animatingOut, setAnimatingOut] = useState(false);
  const animatingOutTimeout = useRef(null);

  const onMouseEnter = useCallback(() => {
    if (animatingOutTimeout.current) {
      clearTimeout(animatingOutTimeout.current);
    }
    setIsOpen(true);
    setAnimatingOut(false);
  }, []);

  const onMouseLeave = useCallback(() => {
    setAnimatingOut(true);
    animatingOutTimeout.current = setTimeout(() => {
      setIsOpen(false);
      setAnimatingOut(false);
    }, duration);
  }, [duration]);

  const closeMenu = useCallback(() => {
    setIsOpen(false);
    setAnimatingOut(false);
    if (animatingOutTimeout.current) {
      clearTimeout(animatingOutTimeout.current);
    }
  }, []);

  return { isOpen, animatingOut, onMouseEnter, onMouseLeave, closeMenu };
};
